import { ButtonText } from "components/Atoms/Button";
import { PhosphorAirplaneTilt, PhosphorCar, PhosphorTrain } from "components/Atoms/PhosphorIcon";
import { Panel } from "components/panels";
import { FormatArrivalTime } from "flights/lookup/FlightSearchResult";
import { getLinkedTravelInfo } from "linkedtravel/components/linkedtravelrow";
import moment from "moment";
import React from "react";
import { formatTime, formatWrittenDayMonth } from "utilities";

interface Props {
  isLoading: boolean
  travelAppointments: server.dto.ShowToTravelAppointment[]
  onHide?: (travelAppointment: server.dto.ShowToTravelAppointment) => void
}

export const AdvancingTravelPanel = ({ isLoading, travelAppointments, onHide }: Props) => {
  return <Panel
    panelClassName="s1_panel"
    title="Travel"
    isLoading={isLoading}
    hasData={travelAppointments.length > 0}
    contentCssClass="flex-column gap-small">
    {travelAppointments.map(travelAppointment => {
      const info = getLinkedTravelInfo(travelAppointment.appointment);
      return <AdvancingTravelCard
        key={`${travelAppointment.appointment.type}_${info.id}`}
        appointment={travelAppointment.appointment}
        onHide={onHide && (() => onHide(travelAppointment))} />;
    })}
  </Panel>;
};

const TravelIcon = ({ type }: { type: server.dto.AppointmentTypes }) => {
  switch (type) {
    case "flight": return <PhosphorAirplaneTilt />;
    case "train": return <PhosphorTrain />;
    case "groundTransport": return <PhosphorCar />;
    default: throw new Error(`Unexpected travel type: ${type}`);
  }
};

interface AdvancingTravelCardProps {
  appointment: server.dto.AppointmentForList
  onHide?: () => void
}

const AdvancingTravelCard = ({ appointment, onHide }: AdvancingTravelCardProps) => {
  const { base, summary } = getLinkedTravelInfo(appointment);
  const startDate = moment.utc(base.dateTime.startDisplay);
  const endDate = moment.utc(base.dateTime.endDisplay);

  return <div className="advancing-travel-card card-surface-standalone">
    <div className="flex-column gap-mini">
      {base.dateTime.mode === "hasTimeStartsInNight" && <div className="text-sublabel">{RESX.DateTime.InTheNightOf}</div>}
      <div>{formatWrittenDayMonth(startDate)}</div>
    </div>
    <div className="flex-column gap-small">
      <div>{summary}</div>
      <div className="flex text-sublabel">
        {formatTime(startDate)}&nbsp;-&nbsp;<FormatArrivalTime departure={startDate} arrival={endDate} />
      </div>
      {base.contactNames && <div>{base.contactNames}</div>}
    </div>
    <div className="flex-column align-end justify-space-between">
      <TravelIcon type={appointment.type} />
      {onHide && <ButtonText className="no-padding" label="Hide" onClick={onHide} />}
    </div>
  </div>;
};
